import './instructions.css'
import paso1 from 'assets/images/paso1-instrucciones.png'
import paso2 from 'assets/images/paso2-instrucciones.png'
import paso3 from 'assets/images/paso3-instrucciones.png'
import paso4 from 'assets/images/paso4-instrucciones.png'
import { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { PrivateRoutes } from 'routes/rutas'
import { openWindowNotification } from '../home/logic'

export default function Instructions({ show, onHide }) {
	const [windowNumber, setWindowNumber] = useState(0)

	const CurrentView = views[windowNumber]

	const resetWindow = () => {
		setWindowNumber(0)
	}

	return (
		<Modal show={show} centered onHide={onHide} onExited={resetWindow} backdrop='static'>
			<Modal.Header closeButton>
				<span className='h5 mb-0'>Configuración de notificaciones</span>
			</Modal.Header>
			<Modal.Body>
				<CurrentView />
			</Modal.Body>
			<Modal.Footer>
				<Button variant='outline-blue' onClick={onHide}>
					Cerrar
				</Button>
				<Button variant='blue' onClick={() => setWindowNumber(windowNumber - 1)} disabled={windowNumber === 0}>
					{'<'} Anterior
				</Button>
				<Button variant='blue' onClick={() => setWindowNumber(windowNumber + 1)} disabled={windowNumber === 2}>
					Siguiente {'>'}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

const Window1 = () => {
	return (
		<div className='instructions-item'>
			<p className='text-primary'>
				* Para facilitar la configuración de notificaciones se recomienda usar el navegador Google Chrome.
			</p>
			<p>
				<span className='fw-bold me-2'>Paso 1:</span>
				Hacer clic en la primera opción de la Barra de direcciones.
			</p>
			<img src={paso1} alt='Paso 1' />
			<p>
				<span className='fw-bold me-2'>Paso 2:</span>
				Hacer clic en la opción de Configuración.
			</p>
			<img src={paso2} alt='Paso 2' />
		</div>
	)
}
const Window2 = () => {
	return (
		<div className='instructions-item'>
			<p>
				<span className='fw-bold me-2'>Paso 3:</span>
				Permitir las opciones de
				<span className='fst-italic mx-2'>"Ventanas emergentes y redirecciones"</span>y{' '}
				<span className='fst-italic'>"Sonido"</span>.
			</p>
			<img src={paso3} alt='Paso 3' className='mb-2' />
			<p className='text-center text-primary'>* Estas configuraciones solo se aplicarán para este sitio.</p>
			<p>
				<span className='fw-bold me-2'>Paso 4:</span>
				Recargar la página "pst.umss.edu.bo" para que se apliquen las configuraciones.
			</p>
			<img src={paso4} alt='Paso 4' />
		</div>
	)
}
const Window3 = () => {
	const [contador, setContador] = useState(0)

	useEffect(() => {
		if (contador > 0) {
			const timeout = setTimeout(() => {
				setContador(contador - 1)
				if (contador - 1 === 0) {
					openWindowNotification(PrivateRoutes.CONTROLPERMANENCIATEST)
				}
			}, 1000)

			return () => clearTimeout(timeout)
		}
	}, [contador])

	const handleClick = () => {
		// El navegador considera como pop-up a una ventana que se abre después de un corto tiempo de inactividad
		// En Chrome, Firefox y Brave se requiere por lo menos 5 segundos de inactividad
		setContador(5)
	}

	return (
		<div className='instructions-item'>
			<p>Si llegaste hasta este punto, las notificaciones ya deben estar habilitadas.</p>
			<p>Para probar el funcionamiento de las notificaciones, puede dar clic en el siguiente botón:</p>
			<Button className='w-100 mb-3' variant='blue' onClick={handleClick}>
				Mostrar notificación
			</Button>
			<div className='d-flex'>
				{contador > 0 && (
					<div className='spinner-container mx-auto mb-3'>
						<div className='spinner'></div>
						<div className='fs-3'>{contador}</div>
					</div>
				)}
			</div>
			<div className='text-primary text-center'>
				* Si experimentas algún problema, te recomendamos contactar con el administrador.
			</div>
		</div>
	)
}

const views = {
	0: Window1,
	1: Window2,
	2: Window3,
}
